module.exports = __webpack_public_path__ + "static/media/frc-halloween-image-1.42ff03f4.png";